<template>
	<div>
		<!--头-开始-->
		<header class="header hdFF Huans flexC">
			<a href="javascript:history.back();" class="hdFF_left">
				<span class="iconfontll icon-zuojiantou"></span>
			</a>
			<div class="hdFFCon">
				<span class="hdname">{{$t('message.'+Title)}}</span>
				<span v-if="isIcon" class="hdFFicon iconfontll icon-yanzhengma1"></span>
			</div>
			<div class="headfrbox flexC">
				<!-- <router-link :to="{name: 'kefu'}" class="headfritem flexC">
					<img src="@/assets/wap/images/icon/kficon.png" />
					<span>{{$t('message.kefu')}}</span>
				</router-link> -->
				<div @click="showkfPopup()" class="headfritem flexC">
					<img src="@/assets/wap/images/icon/kficon.png" />
					<span>{{$t('message.kefu')}}</span>
				</div>
			</div>
		</header>
		<!--导航-开始-->
		<!-- 客服弹窗start -->
		<kefuPop v-if="kfshow" @close="closekfPopup"></kefuPop>
		<!-- 客服弹窗end -->
	</div>
	<!--导航-结束-->
</template>

<script>
	import kefuPop from '@/components/wap/public/kefupop.vue';
	export default {
		components: {
			kefuPop
		},
		props: {
			Title: {
				type: String,
				default: ""
			},
			isIcon: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				kfshow: false, //是否显示客服弹窗
			}
		},
		created() {

		},
		methods: {
			//跳转地址
			navigate(path) {
				//判断是否登录
				if (this.isLogin == false) {
					this.$toast(this.$t('message.plogin'));
					return false;
				}
				this.$router.push({
					path: path
				});
			},
			// 打开客服弹窗
			showkfPopup() {
				this.kfshow = true;
				// console.log(this.kfshow,"showkfPopup")
			},
			// 关闭客服弹窗
			closekfPopup() {
				this.kfshow = false;
				// console.log(this.kfshow,"closekfPopup")
			},

		}
	}
</script>

<style lang="less" scoped>
	.header {
		height: 46px;
	}
</style>


// WEBPACK FOOTER //
// src/components/wap/public/header.vue